import React from "react";
import ReactDom from "react-dom";

import {extendObservable, observable, action, computed} from 'mobx';
import {observer} from 'mobx-react';

import BaseViewStore from 'base-viewstore';

import {InputFieldContentModel} from '../inputFields/contentmodel';
import {checkInstanceOf} from 'base-contentmodel/utils'


export class ControlGroupViewStore extends BaseViewStore {

    @computed get isValid() {
        return true;
    }

    @computed get hasChanged() {
        return this.props.contentModel.value != lastValue;
    }



    // validation is a derivation
    @computed get invalid() {
        const invalid = {};
        /*const {
            contentModel,
            inputStore: {
                getInput,
                setInput
            }
        } = this.props;

        const userInputValue = getInput(contentModel, "userInput")

        if(!userInputValue) invalid.userInput = "User, please provide a value!"*/

        return invalid;
    }  

    @action.bound save() {
    }
}

export class FormViewStore extends BaseViewStore {

    @observable valid = false;
    @observable updating = false;

    dbVariableStore = {};
    updatedValues = {};
    isSubmitting = false;
    controls = [];
    lastUpdate = 0;
    updateTimer = 0;

    constructor(props) {
        super(props);
    }

    @action.bound update() {
        var valid = true;

        var variables = {};

        for(var i = 0; i < this.controls.length; ++i) {
            var control = this.controls[i];
            if(control && typeof(control.valid) !== 'undefined' && control.props.contentModel.required) {
                valid = valid && control.valid;
            }
        }

        this.valid = valid;

        if(this.valid) {
            this.save();
        }
    }

    // validation is a derivation
    @computed get invalid() {
        const invalid = {};
        return invalid;
    }  

    @action.bound save() {
        let self = this;
        const {
            contentModel,
            inputStore,
        } = this.props;

        for(let i = 0; i < this.controls.length; ++i) {
            let control = this.controls[i];
            if(control.props.contentModel.variable && control.valid) {
                if(this.dbVariableStore[control.props.contentModel.variable] != control.value) {
                    let base = control.props.contentModel.variable.substring(0, control.props.contentModel.variable.lastIndexOf(":"));
                    self.updatedValues[base + ":" + window.application.dataModel.domainStore.context.team.num5] = control.value;
                    this.dbVariableStore[control.props.contentModel.variable] = control.value;
                }
            }
            /*if(control.props.contentModel.variables && control.valid) {
                for(let j in control.props.contentModel.variables) {
                    if(this.dbVariableStore[j] != control.props.contentModel.variables[j]) {
                        self.updatedValues[j] = control.props.contentModel.variables[j];
                        this.dbVariableStore[j] = control.props.contentModel.variables[j];
                    }
                }
            }*/
        }

        this.lastUpdate = new Date().getTime();
        if(this.isSubmitting) {
            self.runSubmitAction();
        }
        else {
            self.runUpdateAction();
        }
    }
    
    @action.bound runUpdateAction() {
        let self = this;
        const {
            contentModel,
            inputStore,
        } = this.props;  
        
        if(this.updating) {
          console.log("Blocked");
          setTimeout(function() {
            self.runUpdateAction();
          }, 100);
          return;
        }
        
        this.updating = true;
        if(!window.application.dataModel.domainStore.context.team || !window.application.dataModel.domainStore.context.team.pathId) {
            self.updateVariables({});
            return;
        }

        if(!self.updatedValues || Object.keys(self.updatedValues).length == 0 || contentModel.isSubmitted) {
            self.updateVariables({});
            return;
        }

        const tempValues = Object.assign({}, self.updatedValues);
        self.updatedValues = {};

        if(contentModel.updateAction == "runProformaModel") {
            inputStore.simgate.runModel({
                model: "DIOGModel",
                select: "*",
                mode: "Proforma",
                saveOutputs: true,
                period: window.application.dataModel.domainStore.context.team.num5,
                teamnumber: 1,
                actors: [
                    {
                        id: window.application.dataModel.domainStore.context.team.pathId,
                        inputs: tempValues,
                        isTeam: true
                    },
                ],
            })
            .then((result) => {
                const data = result.outputs && result.outputs[window.application.dataModel.domainStore.context.team.pathId] || {};
                self.updateVariables(data);
            })
            .catch((result) => {
                alert(result);
                self.updateVariables({});
            })
            .always(() => {
            });
        }
        else {
            self.updateVariables({});
        }

    }
    
    @action.bound runSubmitAction() {
        let self = this;
        const {
            contentModel,
            inputStore,
        } = this.props;   
        
        if(this.updating) {
          setTimeout(function() {
            self.runSubmitAction();
          }, 100);
          return;
        }
        this.updating = true;
        if(!window.application.dataModel.domainStore.context.team || !window.application.dataModel.domainStore.context.team.pathId) {
            self.updateVariables({});
            return;
        }

        const tempValues = Object.assign({}, self.updatedValues);
        self.updatedValues = {};

        contentModel.isSubmitted = true;

        if(contentModel.submitAction == "proceed") {
            const {
                viewMap,
                selectView,
            } = window.application.shell;

            let first = null;
            let home = null;
            let resources = null;
            let financials = null;
            for(let i in viewMap) {
                const view = viewMap[i];

                if(!home) {
                    home = view;
                }
                else if(!resources) {
                    resources = view;
                }
                else if(!financials) {
                  financials = view;
                }
                if((!first || first == home || first == resources || first == financials) && !view.contentModel.activity.isSubmitted) {
                    first = view;
                }
            }
            
            if(first) {
                selectView(first, viewMap);
            }
        }

        const set = {};
        set[contentModel.id + "_isCompleted"] = true;
        set[contentModel.id + "_isSubmitted"] = true;
        inputStore.simgate.updateData({
            path: window.application.dataModel.domainStore.context.team.pathId,
            set: set
        }).then(action("loadData-callback", res => {
            const data = res.updated || {};
            console.log("Form complete");
            self.isSubmitting = false;
            self.updateControls();
        })).catch(action("loadData-error", err => {
            debugger;
            alert("There was a problem saving your data - " + err);
        }));
    }
    
    @action.bound updateVariables(data) {
        let self = this;
        const {
            contentModel,
            inputStore,
        } = this.props;
        
        for(let i in data) {
            let value = data[i];
            if(value !== undefined) {
                if(!isNaN(parseFloat(value))) {
                    value = parseFloat(value);
                    let rounded = Math.round(value);
                    if(value >= 0.999 && Math.abs(rounded - value) < 0.01) {
                        value = rounded;
                    }
                }
                let base = i.substring(0, i.lastIndexOf(":"));
                let rangeText = i.substring(i.lastIndexOf(":") + 1);
                let start = parseInt(rangeText.charAt(0));

                if(base == "G:FI_DEC_DividendPercent" || base == "G:FI_RES_SumCapitalAllocationPercent") {
                    value *= 100;
                }

                if(self.dbVariableStore[i] !== undefined) {
                    self.dbVariableStore[i] = value;
                }
                if(start == window.application.dataModel.domainStore.context.team.num5 && self.dbVariableStore[base + ":G"] !== undefined) {
                    self.dbVariableStore[base + ":G"] = value;
                }
                
                let end = rangeText.charAt(rangeText.length - 1);
                if(end == "M") { end = window.application.dataModel.domainStore.context.team.num5; }
                else { end = parseInt(end); }
                for(let r = start; r <= end; ++r) {
                    if(self.dbVariableStore[base + ":" + r] !== undefined) {
                        self.dbVariableStore[base + ":" + r] = value;
                    }
                    const diff = r - window.application.dataModel.domainStore.context.team.num5;
                    if(diff < 0 && self.dbVariableStore[base + ":" + diff] !== undefined) {
                        self.dbVariableStore[base + ":" + diff] = value;
                    }
                    else if(self.dbVariableStore[base + ":+" + diff] !== undefined) {
                      self.dbVariableStore[base + ":+" + diff] = value;
                  }
                }
            }
        }

        if(this.dbVariableStore["G:FI_HSEC_Index:G"]) {
            this.props.contentModel.HSEIndex = this.dbVariableStore["G:FI_HSEC_Index:G"];
        }
        self.updateControls();

    }

    @action.bound updateControls() {

        const {
            contentModel,
            inputStore,
        } = this.props;
        
        try {
            let lateUpdate = [];
            for(let i = 0; i < this.controls.length; ++i) {
                let control = this.controls[i];
                if(control.update) {
                    control.update();
                }
                if(control.lateUpdate) {
                    lateUpdate.push(control);
                }
            }
            for(let i = 0; i < lateUpdate.length; ++i) {
                if(lateUpdate[i].lateUpdate) {
                    lateUpdate[i].lateUpdate();
                }
            }
        }
        catch(e) {
            console.error(e);
        }
        
        this.updating = false;
    }
    
    @action.bound createVariables() {
        let self = this;
        const {
            contentModel,
            inputStore,
        } = this.props;   

        this.updating = true;
        let inputs = [];
        
        for(let i = 0; i < this.controls.length; ++i) {
            let control = this.controls[i];
            if(control.props.contentModel.variable) {
                this.dbVariableStore[control.props.contentModel.variable] = control.value;

                if(control.props.contentModel.variable.indexOf(":-1") >= 0) {
                    inputs.push(control.props.contentModel.variable.replace(":-1", ":" + (window.application.dataModel.domainStore.context.team.num5 - 1)));
                }
                else if(control.props.contentModel.variable.indexOf(":+0") >= 0) {
                    inputs.push(control.props.contentModel.variable.replace(":+0", ":" + (window.application.dataModel.domainStore.context.team.num5)));
                }
                else if(control.props.contentModel.variable.indexOf(":G") >= 0) {
                    inputs.push(control.props.contentModel.variable.replace(":G", ":" + (window.application.dataModel.domainStore.context.team.num5)));
                }
                else {
                    inputs.push(control.props.contentModel.variable);
                }
            }
            if(control.props.contentModel.variables) {
                const variables = control.props.contentModel.variables;
                for(let j in variables) {
                    this.dbVariableStore[j] = variables[j];
    
                    if(j.indexOf(":G") >= 0) {
                        inputs.push(j.replace(":G", ":" + (window.application.dataModel.domainStore.context.team.num5)));
                    }
                    else {
                        inputs.push(j);
                    }
                }
            }
        }

        if(window.application.dataModel.domainStore.context.team.num5 >= 2) {
            this.dbVariableStore["G:FI_DEC_Initiative1:1"] = -1;
            this.dbVariableStore["G:FI_DEC_Initiative2:1"] = -1;
            inputs.push("G:FI_DEC_Initiative1:1");
            inputs.push("G:FI_DEC_Initiative2:1");
        }
        if(window.application.dataModel.domainStore.context.team.num5 >= 3) {
            this.dbVariableStore["G:FI_DEC_Initiative1:2"] = -1;
            this.dbVariableStore["G:FI_DEC_Initiative2:2"] = -1;
            inputs.push("G:FI_DEC_Initiative1:2");
            inputs.push("G:FI_DEC_Initiative2:2");
        }
        
        this.isLoading = true;
        
        if(!window.application.dataModel.domainStore.context.team || !window.application.dataModel.domainStore.context.team.pathId || inputs.length == 0) {
            self.updateVariables({});
            return;
        }

        const taskArgs = [
            inputStore.simgate.selectData, {
                select: inputs,
                path: window.application.dataModel.domainStore.context.team.pathId
            },{
                //wrap in action for mobx transaction purposes (only refresh views after complete)
                onSuccess: action("loadData-callback", res => {

                    const data = res.selected && res.selected.data || {};
                    self.updateVariables(data);
                    self.isLoading = false;
                }),
                onFailure: action("loadData-error", err => {
                    debugger;
                    alert("There was a problem loading your data - " + err);
                }),
            }
        ]
    
        if(inputStore.simgate.runTask) {
            inputStore.simgate.runTask(...taskArgs);
        } else if(inputStore.simgate.AsyncTask) {
            const asyncTask = new inputStore.simgate.AsyncTask();
            asyncTask.runTask(...taskArgs);             
        } else {
            inputStore.simgate.selectData(taskArgs[1]).then( taskArgs[2].onSuccess ).catch( taskArgs[2].onFailure );
        }
    }
    
    @action.bound startAutoUpdate() {
        if(!this.props.contentModel.autoUpdate) {
            return;
        }
        let self = this;
        this.updateTimer = setInterval(function() {
            self.autoUpdate();
        }, 30000); // 30 seconds
    }
    @action.bound stopAutoUpdate() {
        clearInterval(this.updateTimer);
        this.updateTimer = 0;
    }

    @action.bound autoUpdate() {
        let self = this;
        const {
            contentModel,
            inputStore,
        } = this.props; 
        
        // if last update was less than 10 seconds ago then don't update now
        if(this.lastUpdate >= (new Date().getTime()) - 10000) {
            return;
        }
        this.lastUpdate = new Date().getTime();

        let inputs = [];
        
        for(let i = 0; i < this.controls.length; ++i) {
            let control = this.controls[i];
            if(control.props.contentModel.variable) {
                if(control.props.contentModel.variable.indexOf(":-1") >= 0) {
                    inputs.push(control.props.contentModel.variable.replace(":-1", ":" + (window.application.dataModel.domainStore.context.team.num5 - 1)));
                }
                else if(control.props.contentModel.variable.indexOf(":+0") >= 0) {
                    inputs.push(control.props.contentModel.variable.replace(":+0", ":" + (window.application.dataModel.domainStore.context.team.num5)));
                }
                else if(control.props.contentModel.variable.indexOf(":G") >= 0) {
                    inputs.push(control.props.contentModel.variable.replace(":G", ":" + (window.application.dataModel.domainStore.context.team.num5)));
                }
                else {
                    inputs.push(control.props.contentModel.variable);
                }
            }
            if(control.props.contentModel.variables) {
                const variables = control.props.contentModel.variables;
                for(let j in variables) {
                    if(j.indexOf(":G") >= 0) {
                        inputs.push(j.replace(":G", ":" + (window.application.dataModel.domainStore.context.team.num5)));
                    }
                    else {
                        inputs.push(j);
                    }
                }
            }
        }
        
        this.updating = true;
        
        if(!window.application.dataModel.domainStore.context.team || !window.application.dataModel.domainStore.context.team.pathId || inputs.length == 0) {
            self.updateVariables({});
            return;
        }

        const taskArgs = [
            inputStore.simgate.selectData, {
                select: inputs,
                path: window.application.dataModel.domainStore.context.team.pathId
            },{
                //wrap in action for mobx transaction purposes (only refresh views after complete)
                onSuccess: action("loadData-callback", res => {

                    const data = res.selected && res.selected.data || {};
                    self.updateVariables(data);
                }),
                onFailure: action("loadData-error", err => {
                    debugger;
                    alert("There was a problem loading your data - " + err);
                }),
            }
        ]
    
        if(inputStore.simgate.runTask) {
            inputStore.simgate.runTask(...taskArgs);
        } else if(inputStore.simgate.AsyncTask) {
            const asyncTask = new inputStore.simgate.AsyncTask();
            asyncTask.runTask(...taskArgs);             
        } else {
            inputStore.simgate.selectData(taskArgs[1]).then( taskArgs[2].onSuccess ).catch( taskArgs[2].onFailure );
        }
    }
}



// WEBPACK FOOTER //
// ./app_modules/form-control-activity/forms/viewstore.js